import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, Card, App, Result, Spin } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import apiClient from '../api/client';

const { Title, Text } = Typography;

const RegisterPage: React.FC = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    apiClient.get('/auth/status').then(({ data }) => {
      if (!data.data.registrationOpen) {
        setClosed(true);
      }
    }).catch(() => {}).finally(() => setChecking(false));
  }, []);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await register(values.email, values.password, 'admin');
      navigate('/');
    } catch (err: any) {
      if (err.response?.status === 403) {
        setClosed(true);
      } else {
        message.error(err.response?.data?.error || 'Registration failed');
      }
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><Spin size="large" /></div>;
  }

  if (closed) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Result
          status="403"
          title="Registration Closed"
          subTitle="An administrator account already exists. Contact your admin to create an account."
          extra={<Link to="/login"><Button type="primary">Go to Login</Button></Link>}
        />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Card style={{ width: 400 }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 8 }}>Proxy Network Diag</Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Create the first administrator account
        </Text>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}>
            <Input prefix={<MailOutlined />} placeholder="Email" aria-label="Email" autoComplete="username" autoFocus size="large" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, min: 8, message: 'Password must be at least 8 characters' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Password (min. 8 characters)" aria-label="Password" autoComplete="new-password" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              Create Admin Account
            </Button>
          </Form.Item>
        </Form>
        <Text style={{ display: 'block', textAlign: 'center' }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </Text>
      </Card>
    </div>
  );
};

export default RegisterPage;
